// src/lib/firebase.js
// Firebase (compat) – works well with CRA/Webpack and older setups.
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

/** Initialize the primary Firebase app (idempotent). */
export function initFirebase() {
  const config = {
    apiKey: "AIzaSyDBNs2IeeOQrdjEU7hpXIpnaSu1JIDCWJI",
    authDomain: "towingportal-8bc42.firebaseapp.com",
    projectId: "towingportal-8bc42",
  };
  if (firebase.apps.length === 0) {
    firebase.initializeApp(config);
  }
}

/**
 * Create (or sign in to) a Firebase user and return its UID.
 * Uses a *secondary* app so it doesn't touch the primary auth state.
 */
export async function ensureFirebaseUser(email, password) {
  const config = {
    apiKey: "AIzaSyDBNs2IeeOQrdjEU7hpXIpnaSu1JIDCWJI",
    authDomain: "towingportal-8bc42.firebaseapp.com",
    projectId: "towingportal-8bc42",
  };

  const secondary = firebase.initializeApp(config, "admin-secondary");
  const sAuth = secondary.auth();

  try {
    let cred;
    try {
      cred = await sAuth.createUserWithEmailAndPassword(email, password);
    } catch (e) {
      if (e?.code === "auth/email-already-in-use") {
        cred = await sAuth.signInWithEmailAndPassword(email, password);
      } else {
        throw e;
      }
    }
    const uid = cred?.user?.uid;
    if (!uid) throw new Error("Failed to obtain Firebase UID");
    return { uid };
  } finally {
    try {
      await sAuth.signOut();
    } catch {}
    try {
      await secondary.delete();
    } catch {}
  }
}

/**
 * Sign in to Firebase (primary app) with email/password and return an ID token.
 * Sets persistence to LOCAL when remember=true, otherwise SESSION.
 * Use this for the *initial* login flow.
 */
export async function getFirebaseIdToken(email, password, remember = true) {
  initFirebase();
  const auth = firebase.auth();

  await auth.setPersistence(
    remember
      ? firebase.auth.Auth.Persistence.LOCAL // survives browser restarts
      : firebase.auth.Auth.Persistence.SESSION // cleared on browser close
  );

  if (auth.currentUser && auth.currentUser.email !== email) {
    await auth.signOut();
  }

  const cred = await auth.signInWithEmailAndPassword(email, password);
  // true => force refresh so backend receives a fresh token
  return await cred.user.getIdToken(true);
}

/**
 * Get a (fresh) ID token for the *currently signed-in* user (no password).
 * Returns "" if nobody is signed in.
 * Use this for silent session refresh when your API returns 401.
 */
export async function getCurrentFirebaseIdToken(force = true) {
  initFirebase();
  const auth = firebase.auth();
  const u = auth.currentUser;
  if (!u) return "";
  return await u.getIdToken(!!force);
}
